import { render, staticRenderFns } from "./select_eventstatus.vue?vue&type=template&id=38a11144&scoped=true"
import script from "./select_eventstatus.vue?vue&type=script&lang=js"
export * from "./select_eventstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a11144",
  null
  
)

export default component.exports